import { Identifier, Timestamp } from 'types/utilityTypes';

import { UserPackage } from '../user-package/user-package';

import type { Appointment } from 'models/appointment/_types';
import type { User } from 'models/user/_types';

export enum VisitStatus {
  Reserved = 'reserved',
  Registered = 'registered',
  Completed = 'completed',
  NoShowed = 'noshowed',
  LateCancelled = 'late_cancelled',
  Cancelled = 'cancelled',
  CancelOrLateCancelled = 'cancel_or_late_cancel',
  Reset = '',
}

export interface Visit {
  id: Identifier;
  userId?: Identifier;
  userName?: string;
  clientId?: string;
  registeredAt?: Timestamp;
  createdAt?: Timestamp;
  userCardOnFile?: string;
  completedAt?: Timestamp;
  noShowAt?: Timestamp;
  cancelledAt?: Timestamp | null;
  checkIn?: Timestamp | null;
  checkInAt?: Timestamp | null;
  checkOutAt?: Timestamp | null;
  appointmentId?: Identifier;
  withGuest?: boolean;
  paid?: boolean;
  paidByPackageId?: Identifier | boolean;
  determinePackageId?: Identifier | boolean;
  bookedById?: Identifier | null;
  bookedByName?: string | null;
  appointment?: Appointment;
  user?: User;
  status: VisitStatus;
  color?: string;
  workoutId?: Identifier;
  cpId?: Identifier;
  workoutDate?: string;
  timeZone?: string;
  locationId?: Identifier;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  hasMembership?: boolean;
  headTrainerId?: Identifier;
  cancelledById?: Identifier | null;
  cancelledByName?: string | null;
  chaperoneVisitId?: Identifier | null;
  chaperoneUserId?: Identifier | null;
  servicePrice?: number;
  noRequirePrepayment?: boolean;
  waitlistEntryId?: Identifier | null;
  noshowFee?: Fee;
  lateFee?: Fee;
  firstVisit?: boolean;
  privateNotes?: string;
  resources?: Resource[];
  package?: UserPackage;
}

export interface Fee {
  id: Identifier;
  amount: number;
  chargedById: Identifier;
  createdAt: Timestamp;
  feeType: 'cancellation' | 'noshow';
  feeableId: Identifier;
  feeableType: string;
  platformId: Identifier;
  status: string | null;
  updatedAt: Timestamp;
  userId: Identifier;
}

export interface Resource {
  id: Identifier;
  name: string;
  description: string;
  locationId: Identifier;
  parentId: Identifier;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  locationName: string;
  parentName: string;
  serviceIds: Identifier[];
  visitDescription: string;
  public: boolean;
}

export interface ScheduledMembership {
  id: Identifier;
  userId: User['id'];
  scheduledAppointmentId: ScheduledAppointment['id'];
  scheduledAppointment: ScheduledAppointment;
  createdAt: number;
  userCardOnFile: string;
  clientId: number;
  userName: string;
  days: number[];
  startAt: Date;
  endAt: Date | null;
  recurringStartAt: Date;
  recurringType: string;
  recurringCount: number;
  recurringDayNumbers: number[];
  updatedAt: number;
}

export interface ScheduledAppointment {
  id: Identifier;
  startTime: Timestamp;
  endTime: Timestamp;
  startAt: string;
  endAt: string | null;
  description: string;
  status: string;
  days: number[];
  recurringType: string;
  recurringCount: number;
  serviceId: number;
  locationId: number;
  platformId: number;
  trainerIds: number[];
  notes: string | null;
  links: {
    members: string;
  };
  serviceName: string;
  zoom: any | null;
  zoomMeeting: any | null;
  bookRecurring: any | null;
  maxVisitDays: number | null;
  primaryTrainerIds: number[];
  secondaryTrainerIds: number[];
  trainerNames: string[];
  recurringStartAt: string;
  recurringDayNumbers: number[];
  serviceResourceRules: any[];
  noResources: any | null;
  createdAt: number;
  updatedAt: number;
}
